import useRateChange from '@/hooks/useRateChange'
import { bigNumberMultipliedBy } from '@/utils/tools'
import type { BasePriceItem } from 'api-price'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

const Volume: FC<BasePriceItem> = ({ volume, fiat }) => {
  const { formatRateChangePrice } = useRateChange()
  return (
    <span className="text-1 size-16 font-500">
      {fiat?.symbol ?? ''}
      {formatRateChangePrice(bigNumberMultipliedBy(volume, fiat?.rate ?? '1'), {
        isUnit: !fiat?.symbol,
        isThousands: true,
      })}
      {/* {formatRateChangePrice(volume, { isThousands: true, isUnit: true })} */}
    </span>
  )
}

export default observer(Volume)
